module.exports = __webpack_public_path__ + "img/cc.58a75e32.svg";